/* eslint-disable no-underscore-dangle */
const shouldGroupComponents = (contentArea, nextComponent, isLandingPage) => {
  if (isLandingPage && nextComponent.__typename === 'ContentfulClientLogos') return false;

  const canBeSticky = ['Title and right column', 'Eyebrow and title', 'Description with client logos'].includes(contentArea.layout);

  return (canBeSticky && !!nextComponent?.image) || nextComponent.__typename === 'ContentfulClientLogos';
};

export default shouldGroupComponents;
